import React, { useState, useEffect, useCallback, useRef } from 'react';
import apiService from '../services/api';

// SMS liste avtohiš (admin): poimenovane liste, pregled statusa in pošiljanje z lastnega telefona.
// Sporočila gredo v vrsto admina; odda jih Android aplikacija AvtoRadar (prijava admin, "Začni pošiljati").
function DealerSmsLists({ reloadKey, onChanged, showOk, showError }) {
  const [lists, setLists] = useState([]);
  const [openId, setOpenId] = useState(null);
  const [detail, setDetail] = useState(null);
  const [message, setMessage] = useState('');
  const [sending, setSending] = useState(false);
  const [result, setResult] = useState(null);
  const errRef = useRef(showError);
  errRef.current = showError;

  const load = useCallback(async () => {
    try {
      const res = await apiService.getDealerSmsLists();
      setLists(res.data.lists || []);
    } catch (e) { /* 403 prikaze glavna plosca */ }
  }, []);

  const loadDetail = useCallback(async (id) => {
    try {
      const res = await apiService.getDealerSmsList(id);
      setDetail(res.data);
    } catch (e) {
      errRef.current(e, 'Napaka pri branju liste');
    }
  }, []);

  useEffect(() => { load(); }, [load, reloadKey]);
  useEffect(() => { if (openId) loadDetail(openId); }, [openId, reloadKey, loadDetail]);

  const open = (id) => {
    setResult(null);
    if (openId === id) { setOpenId(null); setDetail(null); return; }
    setOpenId(id);
  };

  const rename = async (l) => {
    const name = window.prompt('Novo ime liste:', l.name);
    if (!name || !name.trim()) return;
    try { await apiService.renameDealerSmsList(l.id, name.trim()); load(); if (openId === l.id) loadDetail(l.id); }
    catch (e) { showError(e, 'Napaka pri preimenovanju'); }
  };

  const remove = async (l) => {
    if (!window.confirm(`Izbrisati listo "${l.name}"? (Avtohiše in poslani SMS-i ostanejo.)`)) return;
    try {
      await apiService.deleteDealerSmsList(l.id);
      if (openId === l.id) { setOpenId(null); setDetail(null); }
      load(); onChanged && onChanged();
    } catch (e) { showError(e, 'Napaka pri brisanju liste'); }
  };

  const removeMember = async (dealerId) => {
    try { await apiService.removeFromDealerSmsList(openId, [dealerId]); loadDetail(openId); load(); }
    catch (e) { showError(e, 'Napaka pri odstranjevanju'); }
  };

  const send = async () => {
    if (!detail) return;
    const msg = message.trim();
    if (!msg) { showError(null, 'Vpiši sporočilo.'); return; }
    if (!window.confirm(`Pošljem SMS ${detail.lahko} avtohišam iz liste "${detail.name}"?\n\nOdda jih tvoj Android telefon (aplikacija AvtoRadar, okno 08–20). Prejemniki so nato 6 mesecev blokirani.`)) return;
    setSending(true);
    try {
      const res = await apiService.sendDealerSmsList(detail.id, msg);
      setResult(res.data);
      showOk(`V vrsto dodanih: ${res.data.queued}`);
      loadDetail(detail.id); onChanged && onChanged();
    } catch (e) {
      showError(e, 'Napaka pri pošiljanju');
    } finally {
      setSending(false);
    }
  };

  const badge = (m) => (
    <span style={{
      padding: '2px 8px', borderRadius: 10, fontSize: 12, whiteSpace: 'nowrap',
      background: m.smsLahko ? '#e7f6e7' : '#fdecea', color: m.smsLahko ? '#1b7a1b' : '#b3261e',
    }}>{m.smsStatus}</span>
  );

  return (
    <div style={{ border: '1px solid #ddd', borderRadius: 8, padding: 16, marginBottom: 20 }}>
      <div style={{ fontWeight: 600, marginBottom: 4 }}>SMS liste avtohiš</div>
      <div style={{ fontSize: 13, color: '#555', marginBottom: 12 }}>
        Označi avtohiše v tabeli spodaj in jih dodaj v listo. SMS odda tvoj Android telefon
        (aplikacija AvtoRadar, prijava kot admin, »Začni pošiljati«), v oknu 08–20.
        Prejemniki so 6 mesecev blokirani; NAŠA STRANKA in IZKLJUČI nikoli ne dobita SMS.
      </div>
      {lists.length === 0 ? <div style={{ color: '#888', fontSize: 13 }}>Še ni list.</div> : (
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
          <tbody>
            {lists.map((l) => (
              <React.Fragment key={l.id}>
                <tr style={{ borderBottom: '1px solid #eee', background: openId === l.id ? '#f0f6ff' : undefined }}>
                  <td style={{ padding: 8, fontWeight: 600 }}>{l.name}</td>
                  <td style={{ padding: 8, color: '#555' }}>{l.count} avtohiš</td>
                  <td style={{ padding: 8, color: '#888' }}>{l.createdAt ? new Date(l.createdAt).toLocaleDateString('sl-SI') : ''}</td>
                  <td style={{ padding: 8, textAlign: 'right', whiteSpace: 'nowrap' }}>
                    <button onClick={() => open(l.id)} style={{ padding: '4px 10px', marginRight: 6 }}>{openId === l.id ? 'Zapri' : 'Odpri'}</button>
                    <button onClick={() => rename(l)} style={{ padding: '4px 10px', marginRight: 6 }}>Preimenuj</button>
                    <button onClick={() => remove(l)} style={{ padding: '4px 10px', color: '#d00' }}>Briši</button>
                  </td>
                </tr>
                {openId === l.id && detail && detail.id === l.id ? (
                  <tr>
                    <td colSpan={4} style={{ padding: 12, background: '#fafafa' }}>
                      <div style={{ marginBottom: 8, fontSize: 13 }}>
                        <b>{detail.lahko}</b> od {detail.members.length} lahko dobi SMS.
                        {detail.sendMode && detail.sendMode !== 'naprava' ? (
                          <span style={{ color: '#b3261e', marginLeft: 8 }}>Pozor: način pošiljanja računa ni »naprava«.</span>
                        ) : null}
                      </div>
                      <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13, marginBottom: 12 }}>
                        <thead>
                          <tr style={{ textAlign: 'left', color: '#555', borderBottom: '1px solid #ddd' }}>
                            <th style={{ padding: 6 }}>Avtohiša</th><th style={{ padding: 6 }}>SMS številka</th>
                            <th style={{ padding: 6 }}>NOVO</th><th style={{ padding: 6 }}>Status</th>
                            <th style={{ padding: 6 }}>Zadnji SMS</th><th style={{ padding: 6 }}></th>
                          </tr>
                        </thead>
                        <tbody>
                          {detail.members.map((m) => (
                            <tr key={m.id} style={{ borderBottom: '1px solid #eee' }}>
                              <td style={{ padding: 6 }}>{m.name || `broker ${m.brokerNumber}`}<div style={{ color: '#888' }}>{m.address}</div></td>
                              <td style={{ padding: 6 }}>{m.smsPhone || '—'}</td>
                              <td style={{ padding: 6 }}>{m.newAdsCount != null ? m.newAdsCount : '—'}</td>
                              <td style={{ padding: 6 }}>{badge(m)}</td>
                              <td style={{ padding: 6 }}>{m.zadnjiSms || '—'}</td>
                              <td style={{ padding: 6, textAlign: 'right' }}>
                                <button onClick={() => removeMember(m.id)} style={{ padding: '2px 8px', color: '#d00' }}>Odstrani</button>
                              </td>
                            </tr>
                          ))}
                          {detail.members.length === 0 ? <tr><td colSpan={6} style={{ padding: 6, color: '#888' }}>Lista je prazna — označi avtohiše v tabeli in klikni »Dodaj v listo«.</td></tr> : null}
                        </tbody>
                      </table>
                      <textarea
                        value={message}
                        onChange={(e) => setMessage(e.target.value)}
                        rows={4}
                        maxLength={600}
                        placeholder="Besedilo SMS za avtohiše …"
                        style={{ width: '100%', padding: 8, boxSizing: 'border-box' }}
                      />
                      <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginTop: 6 }}>
                        <span style={{ fontSize: 12, color: '#888' }}>{message.length}/600 znakov</span>
                        <button
                          onClick={send}
                          disabled={sending || detail.lahko === 0 || !message.trim()}
                          style={{ marginLeft: 'auto', padding: '8px 16px', background: '#007AFF', color: 'white', border: 'none', borderRadius: 6 }}
                        >
                          {sending ? 'Dodajam v vrsto …' : `Pošlji SMS (${detail.lahko})`}
                        </button>
                      </div>
                      {result ? (
                        <div style={{ marginTop: 8, fontSize: 13 }}>
                          V vrsto dodanih: <b>{result.queued}</b>
                          {Object.keys(result.skipped || {}).length ? (
                            <> · preskočeni: {Object.entries(result.skipped).map(([k, v]) => `${k} (${v})`).join(', ')}</>
                          ) : null}
                          <div style={{ color: '#555', marginTop: 4 }}>Na telefonu odpri AvtoRadar → SMS vrsta → »Začni pošiljati«.</div>
                        </div>
                      ) : null}
                    </td>
                  </tr>
                ) : null}
              </React.Fragment>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}

export default DealerSmsLists;
